import React, { useState, useEffect } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
import { adminMainUrl } from '../../../../Config';
import { getAllApprovedCustomers, getCompanyBranch, getJobOrderEmployeeList, getJobOrderList, getUnusedQuotationList } from '../../../../Redux/action/Joborder/JoborderAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { DDMMMYYYYformateDate } from '../../../../HelperFunctions';
import axios from 'axios';
import { useFormik } from 'formik';
import ReactPaginate from 'react-paginate';
import AddJobOrderByQuotationOffcanvas from './AddJobOrderByQuotationOffcanvas';
import AddJobOrderByQuotationOffcanvas2 from './AddJobOrderByQuotationOffcanvas2';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Tabbings from '../Forwarding/Tabs/Tabbings';

const JobOrderMaster = ({ title, trans_mode, service_type, impexp, accessedModules, accessedPermission, showTabs, console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, tab_imp_exp, tab_air_sea }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState([]);
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    const [query, setQuery] = useState("");
    const [paginationPage, setPaginationPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(location.search); // Use URLSearchParams
        const savedPage = params.get("page");
        return savedPage ? Number(savedPage) : 1;
    });
    const queryParams = new URLSearchParams(location.search);
    const queryString = new URLSearchParams(location.search).toString();

    const [branch_company_id, set_Branch_company_id] = useState("");

    useEffect(() => {
        if (branch_company_id) {
            dispatch(getCompanyBranch(token, user_id, branch_company_id));
        }
    }, [branch_company_id])

    useEffect(() => {
        setQuery(queryString);
        if (queryParams.get("page")) {
            setPaginationPage(Number(queryParams.get("page") - 1))
        } else {
            setPaginationPage(0);
        }
    }, [queryParams]);

    useEffect(() => {
        if (user_id && token) {
            dispatch(getJobOrderList(token, user_id, trans_mode, service_type, impexp, queryParams.get("page") ?? 1, queryString));
        }
    }, [query]);




    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderList(token, user_id, trans_mode, service_type, impexp, queryParams.get("page") ?? 1, queryString));
            dispatch(getUnusedQuotationList(token, user_id));
            dispatch(getJobOrderEmployeeList(token, user_id));
            dispatch(getAllApprovedCustomers(token, user_id));
        } else {
            toast.error("Please login to continue.")
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, q]);


    // Add Job Order
    const [quotation_id, setQuotation_id] = useState("");
    const [quoteOptionArr, setQuoteOptionArr] = useState([]);
    const [quotationOption, setQuotationOptions] = useState([]);
    const [companyName, setCompanyName] = useState("");
    const [company_id, setCompany_id] = useState("");
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [loadingEmployee, setLoadingEmployee] = useState([]);
    const [branchOption, setBranchOption] = useState([]);
    const [disableQuotationField, setDisableQuotationField] = useState(false);
    const [transport_mode, setTransMode] = useState("");
    const [transport_type, setTransType] = useState("");

    const ChangeTransportMode = (val) => { setTransMode(val) }
    const ChangeTransportType = (val) => { setTransType(val) }

    // let [disableTransportMode, setDisableTransportMode] = useState(false);
    // let [disableTransportType, setDisableTransportType] = useState(false);

    const [loadingQuotation, setLoadingQuotation] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const {
        loadingJobOrderList,
        JobOrderList,
        JobOrderListError,

        JobOrderListCurrentPage,
        JobOrderListTotalPage,
        JobOrderListTotalData,

        loadingUnusedQuotationList,
        UnusedQuotationListError,
        UnusedQuotationList,

        loadingJobOrderEmployeeList,
        JobOrderEmployeeListError,
        JobOrderEmployeeList,


        loadingJobOrderApprovedCustomerList,
        JobOrderApprovedCustomerList,
        JobOrderApprovedCustomerListError,

        loadingJobOrderCompanyBranchList,
        JobOrderCompanyBranchList,
        JobOrderCompanyBranchListError
    } = useSelector(state => state?.JoborderReducer);



    useEffect(() => {
        if (JobOrderCompanyBranchList) {
            let arr = [];
            JobOrderCompanyBranchList.map(v => { arr.push({ value: v.id, label: v.branch_name }) });
            setBranchOption(arr);
        }
    }, [JobOrderCompanyBranchList])

    useEffect(() => {
        if (loadingJobOrderEmployeeList) {
            setLoadingEmployee(true);
        } else {
            setLoadingEmployee(false);
        }

        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);

    useEffect(() => {
        if (loadingUnusedQuotationList) {
            setLoadingQuotation(true);
        } else {
            setLoadingQuotation(false);
        }

        if (UnusedQuotationList) {
            let arr = [];
            UnusedQuotationList.map((val) => {
                const customerName = val.customer_data && val.customer_data.name ? `(${val.customer_data.name})` : "";
                const label = `${val.ship_quotation_no} ${customerName}`;

                const trans_mode = val.transport_mode;
                const trans_type = val.transport_type;
                arr.push({ value: val.id, label, trans_mode, trans_type });
            });
            setQuoteOptionArr(arr);
            setQuotationOptions(arr);
        };

    }, [loadingUnusedQuotationList, UnusedQuotationListError, UnusedQuotationList]);

    const handleChangeCompanyBranch = (quotation_id) => {
        try {
            // formik.setFieldValue("customer_id", "");
            // formik.setFieldValue('branch_id', "");
            let config = { headers: { 'auth-token': token, 'user_id': user_id } };
            axios.get(`${adminMainUrl}/api/jobOrder/get-companydetails-on-quotation?quotation_id=${quotation_id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        if (response.data) {
                            if (response.data.data) {
                                if (response.data.data.customer_data) {
                                    // formik.setFieldValue('customer_id', response.data.data.customer_data.id);
                                    setCompanyName(`${response.data.data.customer_data?.name} ${response.data.data.customer_data?.alias ? `(${response.data.data.customer_data?.alias})` : ""} - ${response.data.data.customer_data?.customerType}`);
                                    setCompany_id(response.data.data.customer_data.id);
                                    if (response.data.data.customer_data?.customer_branch) {
                                        if (Array.isArray(response.data.data.customer_data?.customer_branch)) {
                                            let arr = [];
                                            response.data.data.customer_data?.customer_branch.map(val => arr.push({ value: val.id, label: val.branch_name }));
                                            setBranchOption(arr);
                                        } else {
                                            setBranchOption([]);
                                        }
                                    } else {
                                        setBranchOption([]);
                                    }
                                } else {
                                    setCompanyName("");
                                    setCompany_id("");
                                    // formik.setFieldValue('customer_id', "");
                                    setBranchOption([]);
                                }
                            }
                        }
                    } else {
                        console.log(response.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
        } catch (error) {
            // toast.error(error.message);
            console.log(error.message);
        }
    };

    const resetCompanyName = () => {
        setCompanyName("");
    }


    useEffect(() => {
        if (transport_mode && transport_type && !quotation_id) {
            //find all the Quotation -> with these filters
            // console.log(quoteOptionArr);
            let findArr = quoteOptionArr.filter(v => v.trans_mode == transport_mode && v.trans_type == transport_type);
            setQuotationOptions(findArr);
            // console.log(findArr);
        }
    }, [transport_mode, transport_type, quotation_id]);

    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        if (loadingJobOrderList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (JobOrderList) {
            let arr = [];
            JobOrderList.map((val, i) => {
                arr.push({
                    key: i, // Add a unique key for each row
                    SNo: i + 1,
                    Joborderno: val?.job_order_unique_no, // Ensure date formatting as neede
                    has_quotation: val.has_quotation ? "YES" : "NO",
                    is_direct_customer: val.is_direct_customer ? "YES" : "NO",
                    customer: val.job_order_customer_detail ? val.job_order_customer_detail.name : "-",
                    // customer_service_type: val.job_order_customer_detail ? val.job_order_customer_detail.service_type ?? "-" : "-",
                    quotation_no: val.has_quotation ? val?.quotation_number ? val.quotation_number : "-" : "-", // Ensure date formatting as needed
                    quotation_service_type: val.quotation_number ? val.quotation_service_type ?? "-" : "-",
                    Trackingno: val?.tracking_no,
                    Date: DDMMMYYYYformateDate(val?.createdAt),
                    Transportmode: val?.trans_mode,
                    Transporttype: val?.trans_type,

                    // shipment_type: val?.cc_ff ?
                    //     val.cc_ff == "Custom Clearance" ?
                    //         (val.cc_id ? "Custom Clearance" : "-") :
                    //         val.cc_ff == "Freight Forwarding" ?
                    //             (val.ff_id ? <>{`Freight Fowarding ${val.ff_type}`}</> : "-") :
                    //             val.cc_ff === "Both" ?
                    //                 (<>{`${val.cc_id ? "Custom Clearance " : ""}${val.ff_id ? `Freight Forwarding ${val.ff_type}` : ""}`}</>) : ("-")
                    //     : "-"
                    // ,
                    has_cc: val.has_cc == true ? "YES" : "NO",
                    has_ff: val.has_ff == true ? "YES" : "NO",
                    action_old: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    {accessedPermission.includes("edit_job_order") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/edit/${btoa(val?.id)}`) }} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit Job Order
                                    </div>}
                                    {/* {service_type == "custom_clearance" ?
                                        val.cc_id ?
                                            <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(val.cc_id)}`) }} >
                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Custom Clearance
                                            </div>
                                            :
                                            <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/custom-clearance/${trans_mode == "Sea" ? "sea" : "air"}/${service_type == "IMPORTER" ? "import" : "export"}/add?j_id=${btoa(val.id)}`) }} >
                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Custom Clearance
                                            </div>
                                        :
                                        service_type == "freight_forwarding" ?
                                            val.ff_id ?
                                                val.ff_type == "Console HAWB" ?
                                                    accessedPermission.includes("ff_ae_console_shipment_hawb_edit") &&
                                                    <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/console/hawb/edit/${btoa(val.ff_id)}`) }} >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit  Console HAWB
                                                    </div> :
                                                    val.ff_type == "Direct MAWB" ?
                                                        accessedPermission.includes("ff_ae_direct_shipment_edit") &&
                                                        <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/direct/mawb/edit/${btoa(val.ff_id)}`) }} >
                                                            <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Direct MAWB
                                                        </div> :
                                                        <div className="dropdown-item cursor-pointer">
                                                            Network Error
                                                        </div>
                                                :
                                                trans_mode == "Air" ?
                                                    accessedPermission.includes("ff_air_export_add") && <div className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            if (impexp == "importer") {
                                                                navigate(`/flexichain/job-order/freight-forwarding/shipment/air/import/add?j_id=${btoa(val.id)}`)
                                                            } else {
                                                                navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/add?j_id=${btoa(val.id)}`)
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight Forwarding
                                                    </div>
                                                    :
                                                    accessedPermission.includes("ff_sea_export_add") && <div className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/export/add?j_id=${btoa(val.id)}`)
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight Forwarding
                                                    </div>
                                            :
                                            null
                                    } */}
                                    {
                                        val.is_direct_customer === false ?
                                            val.cc_ff == "Custom Clearance" ?
                                                val.cc_id ?
                                                    <div className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(val.cc_id)}`)
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Custom Clearance
                                                    </div>
                                                    :
                                                    <div className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(`/flexichain/job-order/custom-clearance/${val.air_sea}/${val.imp_exp}/add?j_id=${btoa(val.id)}`)
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Custom Clearance
                                                    </div>
                                                :
                                                null
                                            :
                                            val.is_direct_customer === true ?
                                                val.job_order_customer_detail && val.job_order_customer_detail.service_type ?
                                                    (val.job_order_customer_detail.service_type == "Customer Clearance" || val.job_order_customer_detail.service_type == "Both") ?
                                                        val.cc_id ?
                                                            <div className="dropdown-item cursor-pointer"
                                                                onClick={() => {
                                                                    navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(val.cc_id)}`)
                                                                }}
                                                            >
                                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Custom Clearance
                                                            </div>
                                                            :
                                                            <div className="dropdown-item cursor-pointer"
                                                                onClick={() => {
                                                                    navigate(`/flexichain/job-order/custom-clearance/${val.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/add?j_id=${btoa(val.id)}`)
                                                                }}
                                                            >
                                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Custom Clearance
                                                            </div>
                                                        : null
                                                    :
                                                    null
                                                :
                                                null
                                    }
                                    {
                                        val.is_direct_customer === false ?
                                            val.cc_ff == "Freight Forwarding" ?
                                                val.ff_id ?
                                                    <div className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            val.ff_type == "Direct MAWB" ?
                                                                navigate(`/flexichain/job-order/freight-forwarding/shipment/${val.air_sea}/${val.imp_exp}/direct/${val.air_sea == "air" ? "mawb" : "mbl"}/edit/${btoa(val.ff_id)}`) :
                                                                navigate(`/flexichain/job-order/freight-forwarding/shipment/${val.air_sea}/${val.imp_exp}/console/${val.air_sea == "air" ? "hawb" : "hbl"}/edit/${btoa(val.ff_id)}`)
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Freight Forwarding <>{val.ff_type}</>
                                                    </div>
                                                    :
                                                    <div className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(`/flexichain/job-order/freight-forwarding/shipment/${val.air_sea}/${val.imp_exp}/add?j_id=${btoa(val.id)}`)
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight Forwarding
                                                    </div>
                                                :
                                                null
                                            :
                                            val.is_direct_customer === true ?
                                                val.job_order_customer_detail && val.job_order_customer_detail.service_type ?
                                                    (val.job_order_customer_detail.service_type == "Freight Forwarding" || val.job_order_customer_detail.service_type == "Both") ?
                                                        val.ff_id ?
                                                            <div className="dropdown-item cursor-pointer"
                                                                onClick={() => {
                                                                    val.ff_type == "Direct MAWB" ?
                                                                        navigate(`/flexichain/job-order/freight-forwarding/shipment/${val.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/direct/${val.trans_mode.toLowerCase() == "air" ? "mawb" : "mbl"}/edit/${btoa(val.ff_id)}`) :
                                                                        navigate(`/flexichain/job-order/freight-forwarding/shipment/${val.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/console/${val.trans_mode.toLowerCase() == "air" ? "hawb" : "hbl"}/edit/${btoa(val.ff_id)}`)
                                                                }}
                                                            >
                                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Freight Forwarding <>{val.ff_type}</>
                                                            </div>
                                                            :
                                                            <div className="dropdown-item cursor-pointer"
                                                                onClick={() => {
                                                                    navigate(`/flexichain/job-order/freight-forwarding/shipment/${val.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/add?j_id=${btoa(val.id)}`)
                                                                }}
                                                            >
                                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight Forwarding
                                                            </div>
                                                        :
                                                        null
                                                    :
                                                    null
                                                :
                                                null
                                    }
                                    {
                                        val.cc_ff === "Both" ? (
                                            <>
                                                {val.ff_id ? (
                                                    <div
                                                        className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            val.ff_type === "Direct MAWB"
                                                                ? navigate(
                                                                    `/flexichain/job-order/freight-forwarding/shipment/${val.air_sea}/${val.imp_exp}/direct/mawb/edit/${btoa(val.ff_id)}`
                                                                )
                                                                : navigate(
                                                                    `/flexichain/job-order/freight-forwarding/shipment/${val.air_sea}/${val.imp_exp}/console/hawb/edit/${btoa(val.ff_id)}`
                                                                );
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Freight
                                                        Forwarding <>{val.ff_type}</>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(
                                                                `/flexichain/job-order/freight-forwarding/shipment/${val.air_sea}/${val.imp_exp}/add?j_id=${btoa(val.id)}`
                                                            );
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight
                                                        Forwarding
                                                    </div>
                                                )}

                                                {val.cc_id ? (
                                                    <div
                                                        className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(val.cc_id)}`);
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Custom Clearance
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="dropdown-item cursor-pointer"
                                                        onClick={() => {
                                                            navigate(
                                                                `/flexichain/job-order/custom-clearance/${val.air_sea}/${val.imp_exp}/add?j_id=${btoa(val.id)}`
                                                            );
                                                        }}
                                                    >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Custom Clearance
                                                    </div>
                                                )}
                                            </>
                                        ) : null
                                    }

                                    {
                                        // accessedPermission.includes("edit_job_order") && 
                                        <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/operation/expense/${btoa(val?.id)}`) }} >
                                            <i className="fa-solid fa-money-bills text-blue me-2"></i> Add Expense
                                        </div>}
                                </div>
                            </div>
                        </>
                    ),
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    {
                                        accessedPermission.includes("edit_job_order") &&
                                        <Link className="dropdown-item cursor-pointer" to={`/flexichain/job-order/edit/${btoa(val?.id)}`} >
                                            <i className="ti ti-edit text-blue me-2"></i> Edit Job Order
                                        </Link>
                                    }
                                    {
                                        // accessedPermission.includes("edit_job_order") && 
                                        val.has_cc == true ?
                                            val.cc_id ?
                                                <Link className="dropdown-item cursor-pointer" to={`/flexichain/custom-clearance/${val.trans_type.toLowerCase()}-job/edit/${btoa(val.cc_id)}`} >
                                                    <i className="fa-solid fa-c text-blue me-2"></i> Edit Custom Clearance
                                                </Link> :
                                                <Link className="dropdown-item cursor-pointer" to={`/flexichain/job-order/custom-clearance/${val?.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/add?j_id=${btoa(val.id)}`} >
                                                    <i className="fa-solid fa-c text-blue me-2"></i> Add Custom Clearance
                                                </Link> : null
                                    }
                                    {
                                        // accessedPermission.includes("edit_job_order") && 
                                        val.has_ff == true ?
                                            val.ff_id ?
                                                ((val.trans_mode.toLowerCase() == "air" && val.ff_type == "Direct MAWB") ||
                                                    (val.trans_mode.toLowerCase() == "sea" && val.ff_type == "Direct MBL")) ?
                                                    <Link className="dropdown-item cursor-pointer" to={`/flexichain/job-order/freight-forwarding/shipment/${val?.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/direct/${val.trans_mode.toLowerCase() == "air" ? "mawb" : val.trans_mode.toLowerCase() == "sea" ? "mbl" : null}/edit/${btoa(val.ff_id)}`} >
                                                        <i className="fa-solid fa-f text-blue me-2"></i> Edit Freight Forwarding
                                                    </Link> :
                                                    ((val.trans_mode.toLowerCase() == "air" && val.ff_type == "Console HAWB") ||
                                                        (val.trans_mode.toLowerCase() == "sea" && val.ff_type == "Console HBL")) ?
                                                        <Link className="dropdown-item cursor-pointer" to={`/flexichain/job-order/freight-forwarding/shipment/${val?.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/console/${val.trans_mode.toLowerCase() == "air" ? "hawb" : val.trans_mode.toLowerCase() == "sea" ? "hbl" : null}/edit/${btoa(val.ff_id)}`} >
                                                            <i className="fa-solid fa-f text-blue me-2"></i> Edit Freight Forwarding
                                                        </Link> : null
                                                :
                                                <Link className="dropdown-item cursor-pointer" to={`/flexichain/job-order/freight-forwarding/shipment/${val?.trans_mode.toLowerCase()}/${val.trans_type.toLowerCase()}/add?j_id=${btoa(val.id)}`} >
                                                    <i className="fa-solid fa-f text-blue me-2"></i> Add Freight Forwarding
                                                </Link> : null
                                    }
                                    {
                                        <Link className="dropdown-item cursor-pointer" to={`/flexichain/operation/expense/${btoa(val?.id)}`} >
                                            <i className="fa-solid fa-money-bills text-blue me-2"></i> Add Expense
                                        </Link>
                                    }
                                </div>
                            </div>
                        </>
                    ),
                })
            });
            setDataSource(arr);
            // if (JobOrderListTotalData) {
            //     setTotalItems(JobOrderListTotalData);
            // }

            if (JobOrderListTotalPage) {
                setTotalPages(JobOrderListTotalPage)
            }
        }
    }, [
        loadingJobOrderList,
        JobOrderList,
        JobOrderListCurrentPage,
        JobOrderListTotalPage,
        JobOrderListTotalData
    ]);

    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Joborder No.", dataIndex: "Joborderno", key: "Joborderno" },
        { title: "Has Quotation", dataIndex: "has_quotation", key: "has_quotation" },
        { title: "By Direct Customer", dataIndex: "is_direct_customer", key: "is_direct_customer" },
        { title: "Customer", dataIndex: "customer", key: "customer" },
        // { title: "Customer Service Type", dataIndex: "customer_service_type", key: "customer_service_type" },
        { title: "Quotation No.", dataIndex: "quotation_no", key: "quotation_no" },
        { title: "Quotation Service Type", dataIndex: "quotation_service_type", key: "quotation_service_type" },
        { title: "Tracking No.", dataIndex: "Trackingno", key: "Trackingno" },
        { title: "Date", dataIndex: "Date", key: "Date" },
        { title: "Transport Mode", dataIndex: "Transportmode", key: "Transportmode" },
        { title: "Transport Type", dataIndex: "Transporttype", key: "Transporttype" },
        // { title: "Shipment Type", dataIndex: "shipment_type", key: "shipment_type" },
        { title: "Has Custom Clearance", dataIndex: "has_cc", key: "has_cc" },
        { title: "Has Freight Forwarding", dataIndex: "has_ff", key: "has_ff" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];



    const handleCheckQuotationCustomClearance = (id) => {
        try {
            const config = {
                headers: {
                    'auth-token': Cookies.get('token'),
                    'user_id': Cookies.get('flexichain_user_id'),
                }
            }

            axios.post(`${adminMainUrl}/api/customClearance/check-cc-exists`, { job_order_id: id }, config)
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.data == true) {
                            navigate(`/flexichain/job-order/freight-forwarding/${trans_mode == "Sea" ? "sea" : "air"}/${service_type == "IMPORTER" ? "import" : "export"}/add?j_id=${btoa(id)}`)
                        } else {
                            toast.error("Please add custom clearance details first.")
                        }
                    } else {
                        let msg = 'Internal server error!';
                        if (res.data && res.data.msg) {
                            msg = res.data.msg
                        }
                        toast.error(msg);
                    }
                }).catch((error) => {
                    console.log(error);
                    toast.error(error.message);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }

    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_text: params.get("search_text") || "",
            trans_mode: params.get("trans_mode") || "",
            trans_type: params.get("trans_type") || "",
        };
    };
    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            // console.log(params);

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getJobOrderList(token, user_id, trans_mode, service_type, impexp, currentPage, queryString));

        },
    });


    const resetFilters = () => {
        try {
            formik.setValues({
                search_text: "",
                trans_mode: "",
                trans_type: "",
            });
            let url = "/flexichain/job-order";
            if (url) {
                navigate(url);
            }
        } catch (error) {
            console.log(error.message);
            toast.error("Some error occured!");
        }
    };


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        {title ?? "Job Order List"}<span className="count-title">{JobOrderListTotalData ?? "0"}</span>
                                                    </h4>
                                                </div>
                                                {showTabs && <Tabbings
                                                    console_manifest_url={console_manifest_url}
                                                    console_master_url={console_master_url}
                                                    console_house_url={console_house_url}
                                                    direct_master_url={direct_master_url}
                                                    job_order_url={job_order_url}
                                                    tab_imp_exp={tab_imp_exp}
                                                    tab_air_sea={tab_air_sea}
                                                    accessedPermission={accessedPermission}
                                                />}
                                                {/* <div className="col-4 text-end">
                                                    <div className="head-icons">
                                                        <a
                                                            href="javascript:void(0);"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            data-bs-original-title="Collapse"
                                                            id="collapse-header"
                                                        >
                                                            <i className="ti ti-chevrons-up" />
                                                        </a>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>
                                <div className="card">

                                    <div className="card-body">

                                        {/* Filter */}
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    <div className="icon-form mb-3 mb-sm-0 mx-1">
                                                        <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Job Order/Quotation No."
                                                            name='search_text'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.search_text}
                                                        />
                                                    </div>
                                                    {!trans_mode && <div className="mb-3 mb-sm-0 mx-1">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name='trans_mode'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.trans_mode}
                                                        >
                                                            <option value="">-Select Transport Mode-</option>
                                                            <option value="Air">Air</option>
                                                            <option value="Sea">Sea</option>
                                                        </select>
                                                    </div>}
                                                    {!service_type && <div className="mb-3 mb-sm-0 mx-1">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name='trans_type'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.trans_type}
                                                        >
                                                            <option value="">-Select Transport Type-</option>
                                                            <option value="Import">Import</option>
                                                            <option value="Export">Export</option>
                                                        </select>
                                                    </div>}

                                                </div>
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    {/* <Tooltip placement="top" title="Print Data">
                                                    <div
                                                        className="btn btn-primary cursor-pointer me-2"
                                                    >
                                                        <i className="ti ti-printer text-white"></i>
                                                    </div>
                                                </Tooltip>
                                                <Tooltip placement="top" title="Export Data">
                                                    <div
                                                        className="btn btn-primary cursor-pointer me-2"
                                                    >
                                                        <i className="fas fa-file-export text-white"></i>
                                                    </div>
                                                </Tooltip>*/}
                                                    <button type='submit' className="btn btn-primary me-2">
                                                        Search
                                                    </button>
                                                    <button type="button" onClick={resetFilters}
                                                        className='btn btn-light me-2'
                                                    >
                                                        Clear
                                                    </button>
                                                    {service_type == 'custom_clearance' ?
                                                        (trans_mode && impexp && (
                                                            (trans_mode == "Air" && impexp == "importer" && accessedPermission.includes("cc_job_order_list_air_import")) ||
                                                            (trans_mode == "Air" && impexp == "exporter" && accessedPermission.includes("cc_job_order_list_air_export")) ||
                                                            (trans_mode == "Sea" && impexp == "exporter" && accessedPermission.includes("cc_job_order_list_sea_export")) ||
                                                            (trans_mode == "Sea" && impexp == "importer" && accessedPermission.includes("cc_job_order_list_sea_import"))
                                                        )) ?
                                                            <div
                                                                className="btn btn-primary cursor-pointer me-2"
                                                                onClick={() => {
                                                                    navigate(`/flexichain/job-order/custom-clearance/${trans_mode == "Sea" ? 'sea' : 'air'}/${impexp == "exporter" ? 'export' : 'import'}/add`)
                                                                }}
                                                            >
                                                                <i className="ti ti-square-rounded-plus me-2" />
                                                                Add Custom Clearance
                                                            </div> : null
                                                        :
                                                        service_type == 'freight_forwarding' ?
                                                            trans_mode == "Air" ?
                                                                accessedPermission.includes("ff_air_export_add") &&
                                                                <div
                                                                    className="btn btn-primary cursor-pointer me-2"
                                                                    // onClick={handleAddShow}
                                                                    onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/${impexp == "importer" ? "import" : "export"}/add`) }}
                                                                >
                                                                    <i className="ti ti-square-rounded-plus me-2" />
                                                                    Add Freight Forwarding
                                                                </div>
                                                                :
                                                                accessedPermission.includes("ff_sea_export_add") && <div
                                                                    className="btn btn-primary cursor-pointer me-2"
                                                                    onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/${impexp == "importer" ? "import" : "export"}/add`) }}
                                                                >
                                                                    <i className="ti ti-square-rounded-plus me-2" />
                                                                    Add Freight Forwarding
                                                                </div>
                                                            :
                                                            accessedPermission.includes("create_job_order") && <div
                                                                className="btn btn-primary cursor-pointer me-2"
                                                                onClick={handleShow}
                                                            // onClick={() => { navigate("/flexichain/job-order/add") }}
                                                            >
                                                                <i className="ti ti-square-rounded-plus me-2" />
                                                                Add Job Order
                                                            </div>
                                                    }

                                                </div>
                                            </div>
                                        </form>
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                dataSource={dataSource} columns={columns} />
                                        </div>
                                        <div className="row align-items-center">
                                            {JobOrderList?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }

            <AddJobOrderByQuotationOffcanvas2
                // quotation_id={quotation_id}
                token={token}
                user_id={user_id}
                show={show}
                handleClose={handleClose}
                companyName={companyName}
                branchOption={branchOption}
                setBranchOption={setBranchOption}
                set_Branch_company_id={set_Branch_company_id}
                branch_company_id={branch_company_id}
                handleChangeCompanyBranch={handleChangeCompanyBranch}
                disableQuotationField={disableQuotationField}
                employeeOptions={employeeOptions}
                disableTransportMode={false}
                disableTransportType={false}
                quotationOption={quotationOption}
                loadingQuotation={loadingQuotation}
                trans_mode={transport_mode}
                trans_type={transport_type}
                ChangeTransportType={ChangeTransportType}
                ChangeTransportMode={ChangeTransportMode}
                disabledHasQuotation={false}
                resetCompanyName={resetCompanyName}
                loadingJobOrderApprovedCustomerList={loadingJobOrderApprovedCustomerList}
                JobOrderApprovedCustomerList={JobOrderApprovedCustomerList}
            />
        </>


    )
}

export default JobOrderMaster